export default __webpack_public_path__ + "92d3f2639114f3821a616746b89f2357.png";